//dependencias
import React, { Component } from 'react';

//componentes
import AutorizarAgenda from './autorizarAgenda'

class Index extends Component {

    render(){
        return(
            <div>
                <AutorizarAgenda />
            </div>
        );
    }

}
export default Index;